<template>
  <a-popover
    :class="tableName"
    v-model:open="popoverColumsIsVisible"
    trigger="click"
    placement="bottomRight"
    :arrow="false"
  >
    <template #content>
      <draggable
        v-model="localDragList"
        tag="div"
        class="columns-table-draggble"
        :class="`${tableName}-draggble`"
        @change="(value: any) => handleChangeDraggble(value)"
        itemKey="test"
      >
        <template #item="{ element: option, index }">
          <div
            class="columns-table-draggble-item"
            :class="[
              `${tableName}-draggble-item`,
              {
                borderBottom: index + 1 === fixedLeftCount,
                borderTop: index === dragList.length - fixedRightCount,
              },
            ]"
          >
            <svg
              style="width: 25px; cursor: grab"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <line x1="3" y1="12" x2="21" y2="12"></line>
                <line x1="3" y1="18" x2="21" y2="18"></line>
              </g>
            </svg>
            <a-checkbox
              style="display: flex"
              :key="option.dataIndex"
              :value="option.dataIndex"
              :checked="!option.hide"
              @change="handleCheckboxChange(option)"
              :disabled="option.disabled"
            >
              {{ option.title }}
            </a-checkbox>
          </div>
        </template>
      </draggable>
    </template>
    <a-button
      :disabled="disabled"
      style="border: 1px solid var(--color-primary-text); padding-inline: 10px"
      >Столбцы</a-button
    >
  </a-popover>
</template>

<script setup lang="ts">
import { computed, defineEmits, onMounted, onUnmounted, ref, watch } from "vue";
import type { TableColumnTypeCustom } from "@/types/claims";
// @ts-ignore
import draggable from "vuedraggable/dist/vuedraggable.common";

type Props<T> = {
  initList: TableColumnTypeCustom<T>[];
  dragList: TableColumnTypeCustom<T>[];
  tableName: string;
  disabled?: boolean;
};

const props = defineProps<Props<any>>();

const emit = defineEmits<{
  "update:dragList": [value: TableColumnTypeCustom[]];
}>();

const localDragList = ref<TableColumnTypeCustom[]>([...props.dragList]);
const popoverColumsIsVisible = ref<boolean>(false);

const fixedLeftCount = computed(() => {
  return props.initList?.filter((item) => item.fixed === "left").length;
});

const fixedRightCount = computed(() => {
  return props.initList?.filter((item) => item.fixed === "right").length;
});

let dynamicStyle: HTMLStyleElement | null = null;

const handleChangeDraggble = (value: any) => {
  const { moved } = value;
  const updatedList = [...localDragList.value];

  localDragList.value.forEach((item, index) => {
    if (index < fixedLeftCount.value) {
      item.fixed = "left";
    } else if (index >= props.dragList.length - fixedRightCount.value) {
      item.fixed = "right";
    } else {
      item.fixed = "";
    }
  });

  localDragList.value = updatedList;
  emit("update:dragList", updatedList);
};

const handleCheckboxChange = (option: TableColumnTypeCustom) => {
  option.hide = !option.hide;
  emit("update:dragList", [...localDragList.value]);
};

watch(
  () => props.dragList,
  (newVal) => {
    localDragList.value = [...newVal];
  },
  { deep: true },
);

onMounted(() => {
  dynamicStyle = document.createElement("style");
  dynamicStyle.innerHTML = `
    .${props.tableName}-draggble-item:nth-child(${fixedLeftCount.value}) {
      border-bottom: 1px solid #969696;
    }
    .${props.tableName}-draggble-item:nth-last-child(${fixedRightCount.value}) {
      border-top: 1px solid #969696;
    }
  `;
  document.head.appendChild(dynamicStyle);
});

onUnmounted(() => {
  if (dynamicStyle) {
    document.head.removeChild(dynamicStyle);
    dynamicStyle = null;
  }
});
</script>

<style scoped lang="scss"></style>
